
import { defineComponent } from 'vue'
import DoctorOrders from './DoctorOrders.vue'
import DoctorDocuments from './DoctorDocuments.vue'
import VitalSigns from './VitalSigns.vue'
import EncounterList from '../encounter/EncounterList.vue'

export default defineComponent({
  name: 'DoctorWorkflow',
  props: ['patient'], 
  components: {
    DoctorOrders,
    DoctorDocuments,
    VitalSigns,
    EncounterList
    // QuillRichText
  },
  data () {
    return {
      tab: null,
      patientSummary: {
        name: 'Strawberry Shortcake Jamz',
        birthdate: '01 Jan 1980',
        age: '43',
        location: 'Ward 12',
        hrn: 332211
      },
      admissionDate: new Date().toISOString().substr(0, 10),
    }
  }
})
